// voiceProfiles.js
export const voiceProfiles = {
    "US English": {
        id: "us_english",
        voices: [
            "am_liam+am_michael",
            "af_sky+af_heart",
            "am_liam+am_onyx",
            "af_jessica",
            "af_kore",
            "am_adam",
            "af_sky",
        ]
    },
    "UK English": {
        id: "uk_english",
        voices: [
            "bm_fable+am_onyx+af_sky",  // male
            "bf_emma+bm_lewis+bf_lily+af_heart",
            "bf_emma+bf_v0isabella+af_heart+af_nicole",
            "bf_alice+af_heart+bm_lewis+af_nicole",
            "bf_emma+bf_lily+af_sky+af_heart",
            "bm_lewis+am_onyx+af_sky+af_heart",
        ]
    },
    "Spanglish": {
        id: "spanglish",
        voices: [
            "em_santa+em_santa+af_nicole", // male
            "em_alex+em_alex+af_jadzia",
            "ef_dora+bf_alice+af_heart",
            "ef_dora+bf_lily+af_aoede",
            "ef_dora+bf_lily+af_nicole",
            "em_alex+ef_dora+af_heart"
        ]
    },
    "Hinglish": {
        id: "hinglish",
        voices: [
            "hf_alpha+hf_alpha+af_sky",
            "hm_omega+hm_omega+af_heart",
            "hm_psi+hf_alpha+af_jadzia",
            "hf_beta+hm_psi+af_nicole",
        ]
    },
    "French English": {
        id: "french_english",
        voices: [
            "ff_siwis+af_heart",
            "ff_siwis+af_nicole",
            "ff_siwis+af_aoede",
            "ff_siwis+af_jadzia"
        ]
    },
    "Japanese English": {
        id: "japanese_english",
        voices: [
            "jf_alpha+af_heart",
            "jm_kumo+am_adam",
        ]
    },
    "Chinese English": {
        id: "chinese_english",
        voices: [
            "zf_xiaoxiao+af_alloy+af_nicole",
            "zm_yunjian+af_alloy+af_nicole",
            "zm_yunxia+af_alloy+af_nicole"
        ]
    },
    "Italian English": {
        id: "italian_english",
        voices: [
            "if_sara+af_heart",
            "im_nicola+am_adam"
        ]
    },
    "Portuguese English": {
        id: "portuguese_english",
        voices: [
            "pf_dora+af_heart",
            "pm_alex+am_adam"
        ]
    },
};

export const defaultProfile = "US English";

export const voiceProfileMixin = {
    data() {
        return {
            selectedProfile: defaultProfile,
            speakerToVoiceMap: new Map(),
            currentVoices: voiceProfiles[defaultProfile].voices
        };
    },
    methods: {
        changeVoiceProfile(profileName) {
            this.selectedProfile = profileName;
            this.currentVoices = voiceProfiles[profileName].voices;
            this.speakerToVoiceMap.clear(); // Reset voice assignments
        },
        getVoiceForSpeaker(speaker) {
            if (!this.speakerToVoiceMap.has(speaker)) {
                const voiceIndex = this.speakerToVoiceMap.size % this.currentVoices.length;
                this.speakerToVoiceMap.set(speaker, this.currentVoices[voiceIndex]);
            }
            return this.speakerToVoiceMap.get(speaker);
        }
    }
};
